/*
  creates a countdown timer based on current date
  accepts date from customizer
*/
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    const timer = this.querySelector(".timer_expired");
    const timerCard = this.querySelector(".countdown__card");
    this.targetDate = new Date(this.dataset.date).getTime();
    if (isNaN(this.targetDate)) {
      timer.textContent = "Invalid date format";
      timerCard.classList.add("timer-card");
      return;
    }
    this.update();
    this.interval = setInterval(this.update.bind(this), 1000);
  }
  update() {
    const timer = this.querySelector(".timer_expired");
    const timerCard = this.querySelector(".countdown__card");
    const currentDate = new Date().getTime();
    const timeRemaining = this.targetDate - currentDate;
    if (timeRemaining <= 0) {
      timer.textContent = "Countdown expired!";
      timerCard.classList.add("timer-card");
      clearInterval(this.interval);
      return;
    }

    const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
    const minutes = Math.floor(
      (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    function formatNumberWithLeadingZero(number) {
      return number < 10 ? `0${number}` : number.toString();
    }
    const hoursElement = this.querySelector(".hours");
    const minutesElement = this.querySelector(".minutes");
    const secondsElement = this.querySelector(".seconds");
    hoursElement.textContent = formatNumberWithLeadingZero(hours) + " Hr";
    minutesElement.textContent = formatNumberWithLeadingZero(minutes) + " Min";
    secondsElement.textContent = formatNumberWithLeadingZero(seconds) + " Sec";
  }
  connectedCallback() {
    this.update();
  }
}
//customElements.define("countdown-timer", CountdownTimer);




// checking the count-down-sale is Enable or disable
const timerCard = document.querySelector('.card_timer');
const stickyHeader = document.querySelector('.shopify-section--header');
const checkbox = timerCard.getAttribute('checked');
if (checkbox === 'true') {
  stickyHeader.classList.add('custom_header_sticky');
} else {
  stickyHeader.classList.remove('custom_header_sticky');
}

